import { Avatar, ETextStyleVariant, GeneralUserUserIcon, Loader, Text } from '@outdoorsyco/bonfire';
import React, { memo } from 'react';
import ReactMarkdown from 'react-markdown';

import ScoutIcon from '@/assets/chatbot/scout-sand-circle.png';

import { EAgentName, useChatbot } from '../../ChatbotProvider';
import { IChatbotMessageProps } from '../ChatbotMessage';
import RentalSearchResult from './FunctionResponseContent/RentalSearchResult';

interface FunctionResponseDisplay {
  text: string;
  content: React.ReactNode;
  timestamp?: Date;
}

const ModelMessage = ({ message }: IChatbotMessageProps) => {
  const { agentName } = useChatbot();

  const functionDisplays: FunctionResponseDisplay[] = [];
  const functionNames = Object.keys(message.function_responses || {});

  switch (agentName) {
    case EAgentName.TRIP_PLANNER:
      functionNames.forEach((name: string) => {
        const functionResponse = message.function_responses?.[name];
        if (functionResponse) {
          switch (name) {
            case 'rental_search':
              functionDisplays.push({
                text: functionResponse.text || '',
                content: <RentalSearchResult key={name} functionResponse={functionResponse} />,
              });
              break;
            default:
              break;
          }
        }
      });
      break;
    default:
      break;
  }

  if (functionDisplays.length === 0 && message.text && !message.loading) {
    functionDisplays.push({
      text: message.text,
      content: null,
      timestamp: message.timestamp,
    });
  }

  if (message.loading) {
    return (
      <div className="flex flex-row items-center justify-start pr-6 gap-2">
        <Avatar
          initials="S"
          imageUrl={ScoutIcon.src}
          defaultBrandIcon={GeneralUserUserIcon}
          round
        />
        <Loader />
      </div>
    );
  }

  if (functionDisplays.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      {functionDisplays.map((display, index) => (
        <div key={index} className="flex flex-col">
          <div className="flex flex-row items-end justify-start pr-6 gap-2 h-max-content">
            <Avatar
              initials="S"
              imageUrl={ScoutIcon.src}
              defaultBrandIcon={GeneralUserUserIcon}
              round
            />
            <div className="p-4 rounded-lg bg-gray-10">
              <Text className="text-gray-800">
                <ReactMarkdown
                  components={{
                    img: () => null,
                    script: () => null,
                    iframe: () => null,
                    object: () => null,
                    embed: () => null,
                  }}>
                  {display.text}
                </ReactMarkdown>
              </Text>
            </div>
          </div>
          {message?.timestamp && (
            <div className="flex justify-start pl-14">
              <Text
                variant={ETextStyleVariant.LegalRegular}
                className="mt-1 text-left text-gray-50">
                {message.timestamp.toLocaleTimeString([], { hour: 'numeric', minute: 'numeric' })}
              </Text>
            </div>
          )}
          {display.content && <div className="pt-4">{display.content}</div>}
        </div>
      ))}
    </div>
  );
};

export default memo(ModelMessage);
